import React, { Suspense, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import LoadingSpinner from './components/LoadingSpinner';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import SessionCloseWarning from './components/auth/SessionTimeOut';
// Lazy imports for all route components
const Layout = React.lazy(() => import('./components/Layout'));
const Dashboard = React.lazy(() => import('./components/Dashboard'));
const FeedbackList = React.lazy(() => import('./components/FeedbackList'));
const Insights = React.lazy(() => import('./components/Insights'));
const Users = React.lazy(() => import('./components/Users'));
const UserAnalyticsDashboard = React.lazy(() => import('./components/UserAnalyticsDashboard'));
const RejectedJobs = React.lazy(() => import('./components/RejectedJobs'));
const Companies = React.lazy(() => import('./components/Companies'));
const EmailTemplates = React.lazy(() => import('./components/Emailtemplates'));
const InfraCost = React.lazy(() => import('./components/InfraCost'));
const InfraAnalyticsDashboard = React.lazy(() => import('./components/InfraAnalytics'));
const Features = React.lazy(() => import('./components/Features'));
const PremiumLimits = React.lazy(() => import('./components/PremiumLimits'));
const CouponCodes = React.lazy(() => import('./components/CouponCodes'));
const Subscription = React.lazy(() => import('./components/Subscription'));
const Login = React.lazy(() => import('./components/auth/Login'))
const SignUp = React.lazy(() => import("./components/auth/SignUp"))
const FreeTrialManager = React.lazy(() => import("./components/FreeTrial"))
const CampaignURLBuilder = React.lazy(() => import("./components/CampaignUrlBuilder"))
const OneonOneMockinterview = React.lazy(() => import('./components/OneonOneMockinterview'))
const InterviewerFeedbackForm = React.lazy(() => import('./components/InterviewerFeedbackForm'))
const InternshipSession = React.lazy(() => import('./components/InternshipSession'))
const Mentors = React.lazy(() => import('./components/Mentors'))
const MentorChat = React.lazy(() => import('./components/MentorChat'))

function App() {
  const handleLogout = useCallback(() => {
    sessionStorage.removeItem('jwtToken');
    sessionStorage.removeItem("userEmail")
    window.location.href = '/login';
  }, []);

  return (
    <Router>
      <div className="App">
        <Suspense fallback={<div className="py-8 text-center text-lg">{<LoadingSpinner />}</div>}>
          <SessionCloseWarning onLogout={handleLogout} />
          <Routes>
            <Route path="login" element={<Login />} />
            <Route path="signup" element={<SignUp />} />
            <Route path="interviewer-feedback-form" element={<InterviewerFeedbackForm />} />
            <Route path="/" element={<ProtectedRoute>
              <Layout />
            </ProtectedRoute>
            }>
              <Route index element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } />
              <Route path="feedback" element={
                <ProtectedRoute>
                  <FeedbackList />
                </ProtectedRoute>
              } />
              <Route path="insights" element={
                <ProtectedRoute>
                  <Insights />
                </ProtectedRoute>
              } />
              <Route path="users" element={
                <ProtectedRoute>
                  <Users />
                </ProtectedRoute>
              } />
              <Route path="user-analytics" element={
                <ProtectedRoute>
                  <UserAnalyticsDashboard />
                </ProtectedRoute>
              } />
              <Route path="rejected-jobs" element={
                <ProtectedRoute>
                  <RejectedJobs />
                </ProtectedRoute>
              } />
              <Route path="companies" element={
                <ProtectedRoute>
                  <Companies />
                </ProtectedRoute>
              } />
              <Route path="email-templates" element={
                <ProtectedRoute>
                  <EmailTemplates />
                </ProtectedRoute>
              } />
              <Route path="infra-cost" element={
                <ProtectedRoute>
                  <InfraCost />
                </ProtectedRoute>
              } />
              <Route path="infra-analytics" element={
                <ProtectedRoute>
                  <InfraAnalyticsDashboard />
                </ProtectedRoute>
              } />
              <Route path="new-features" element={<Features />} />
              <Route path="premium" element={
                <ProtectedRoute>
                  <PremiumLimits />
                </ProtectedRoute>
              } />
              <Route path="coupon-codes" element={
                <ProtectedRoute>
                  <CouponCodes />
                </ProtectedRoute>
              } />
              <Route path="subscription-history" element={
                <ProtectedRoute>
                  <Subscription />
                </ProtectedRoute>
              } />
              <Route path="free-trial-manage" element={
                <ProtectedRoute>
                  <FreeTrialManager />
                </ProtectedRoute>
              } />
              <Route path="campaign-url-builder" element={
                <ProtectedRoute>
                  <CampaignURLBuilder />
                </ProtectedRoute>
              } />
              <Route path="one-on-one-mock-interview" element={
                <ProtectedRoute>
                  <OneonOneMockinterview />
                </ProtectedRoute>
              } />
              <Route path="internship-session" element={
                <ProtectedRoute>
                  <InternshipSession />
                </ProtectedRoute>
              } />
              <Route path="mentors" element={
                <ProtectedRoute>
                  <Mentors />
                </ProtectedRoute>
              } />
              <Route path="mentor-chat" element={
                <ProtectedRoute>
                  <MentorChat />
                </ProtectedRoute>
              } />
            </Route>
            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        </Suspense>
      </div>
    </Router >
  );
}

export default App;
